import { FormattedMoney } from 'components/Formatters';
import { TextContainer } from '../primitives';

const Money = ({ amount, currency }) => (
  <TextContainer my={0}>
    <FormattedMoney amount={amount} currency={currency} />
  </TextContainer>
);

export default Money;
